import { DetailWrapper } from "../../../../../features/ui"
import { VehicleDetail } from "./vehicleDetail"

export const VehicleDetailLoader = () => (
    <DetailWrapper>
        <VehicleDetail />
    </DetailWrapper>
)
